import {EnumDictionary} from "@k/js/delme_globals";
import {
    AnimationWaitingForTargetFactory,
    CLOSED,
    KeyFrameTargetValues,
    MIDDLE,
    OPEN,
    KEYFRAMETARGETS,
} from "@km/animations/animationFactory";
import {useModuleTextOpenStatusStore} from "@km/store/frontendstate/useModuleTextOpenState";

export enum TEXTMODULE_POSSIBLE_STATES {
    closed = "closed",
    textverwaltung = "textverwaltung",
    edit = "edit",
    typeface = "typeface",
    color = "color",
    colorOutline = "colorOutline",
    textlist = "textlist",
}

export const textModulStateBackTarget: EnumDictionary<TEXTMODULE_POSSIBLE_STATES, TEXTMODULE_POSSIBLE_STATES> = {
    [TEXTMODULE_POSSIBLE_STATES.closed]: TEXTMODULE_POSSIBLE_STATES.closed,
    [TEXTMODULE_POSSIBLE_STATES.textverwaltung]: TEXTMODULE_POSSIBLE_STATES.closed,
    [TEXTMODULE_POSSIBLE_STATES.edit]: TEXTMODULE_POSSIBLE_STATES.textverwaltung,
    [TEXTMODULE_POSSIBLE_STATES.typeface]: TEXTMODULE_POSSIBLE_STATES.edit,
    [TEXTMODULE_POSSIBLE_STATES.color]: TEXTMODULE_POSSIBLE_STATES.edit,
    [TEXTMODULE_POSSIBLE_STATES.colorOutline]: TEXTMODULE_POSSIBLE_STATES.edit,
    [TEXTMODULE_POSSIBLE_STATES.textlist]: TEXTMODULE_POSSIBLE_STATES.textverwaltung
}

export type TextAnimateToStateparams = {
    textverwaltung: KEYFRAMETARGETS,
    edit: KEYFRAMETARGETS,
    action_edit: KEYFRAMETARGETS,
    typeface: KEYFRAMETARGETS,
    color: KEYFRAMETARGETS,
    colorShade: KEYFRAMETARGETS,
    colorOutline: KEYFRAMETARGETS,
    outlineShade: KEYFRAMETARGETS,
    textlist: KEYFRAMETARGETS,
}

export const TEXTMODULE_TARGET_STATES: EnumDictionary<TEXTMODULE_POSSIBLE_STATES, TextAnimateToStateparams> = {
    closed: {
        textverwaltung: CLOSED,
        edit: CLOSED,
        action_edit: CLOSED,
        typeface: CLOSED,
        color: CLOSED,
        colorShade: CLOSED,
        colorOutline: CLOSED,
        outlineShade: CLOSED,
        textlist: CLOSED,
    },
    textverwaltung: {
        textverwaltung: OPEN,
        edit: CLOSED,
        action_edit: CLOSED,
        typeface: CLOSED,
        color: CLOSED,
        colorShade: CLOSED,
        colorOutline: CLOSED,
        outlineShade: CLOSED,
        textlist: CLOSED,
    },
    edit: {
        textverwaltung: CLOSED,
        edit: OPEN,
        action_edit: CLOSED,
        typeface: CLOSED,
        color: CLOSED,
        colorShade: CLOSED,
        colorOutline: CLOSED,
        outlineShade: CLOSED,
        textlist: CLOSED,
    },
    color: {
        textverwaltung: CLOSED,
        edit: OPEN,
        action_edit: MIDDLE,
        typeface: CLOSED,
        color: OPEN,
        colorShade: OPEN,
        colorOutline: CLOSED,
        outlineShade: CLOSED,
        textlist: CLOSED,
    },
    colorOutline: {
        textverwaltung: CLOSED,
        edit: OPEN,
        action_edit: MIDDLE,
        typeface: CLOSED,
        color: CLOSED,
        colorShade: CLOSED,
        colorOutline: OPEN,
        outlineShade: OPEN,
        textlist: CLOSED,
    },
    textlist: {
        textverwaltung: CLOSED,
        edit: CLOSED,
        action_edit: CLOSED,
        typeface: CLOSED,
        color: CLOSED,
        colorShade: CLOSED,
        colorOutline: CLOSED,
        outlineShade: CLOSED,
        textlist: OPEN,
    },
    typeface: {
        textverwaltung: CLOSED,
        edit: OPEN,
        action_edit: MIDDLE,
        typeface: OPEN,
        color: CLOSED,
        colorShade: CLOSED,
        colorOutline: CLOSED,
        outlineShade: CLOSED,
        textlist: CLOSED,
    }
}

export function getColorMainAnimation() {
    const openStatusStore = useModuleTextOpenStatusStore();
    return {
        animation: AnimationWaitingForTargetFactory.getLeftRightAnimationpercentWithOpacityAnimation('.km__modules__text--color'),
        keyframes: new KeyFrameTargetValues({targetValue: -100, opacity: 1}, {targetValue: 100, opacity: 0}),
        getterForWatch: () => openStatusStore.getColorState
    }
}

export function getTextColorShadeAnimation() {
    const openStatusStore = useModuleTextOpenStatusStore();
    return {
        animation: AnimationWaitingForTargetFactory.getFadeInOutAnimation(".km__modules__text--color--shade"),
        keyframes: new KeyFrameTargetValues({targetValue: 9999, opacity: 1}, {targetValue: -9999, opacity: 0}),
        getterForWatch: () => openStatusStore.getColorShadeState
    }
}

export function getTextOutlineColorAnimation() {
    const openStatusStore = useModuleTextOpenStatusStore();
    return {
        animation: AnimationWaitingForTargetFactory.getLeftRightAnimationpercentWithOpacityAnimation('.km__modules__text--outline'),
        keyframes: new KeyFrameTargetValues({targetValue: -100, opacity: 1}, {targetValue: 100, opacity: 0}),
        getterForWatch: () => openStatusStore.getColorOutlineState
    }
}

export function getTextOutlineColorShadeAnimation() {
    const openStatusStore = useModuleTextOpenStatusStore();
    return {
        animation: AnimationWaitingForTargetFactory.getFadeInOutAnimation(".km__modules__text--outline--shade"),
        keyframes: new KeyFrameTargetValues({targetValue: 9999, opacity: 1}, {targetValue: -9999, opacity: 0}),
        getterForWatch: () => openStatusStore.getOutlineShadeState
    }
}
